import React from 'react'
import Header from '../layouts/Header'
import Footer from '../layouts/Footer'
import IOSAppSection from '../layouts/IOSpage/IOSAppSection'
import IOSProcessSection from '../layouts/IOSpage/IOSProcessSection'
import IOSFeaturesSection from '../layouts/IOSpage/IOSFeaturesSection'
import FinalCTA from '../layouts/FinalCTA'

const IOSApp = () => {
  return (
    <>
    <Header/>
    <IOSAppSection/>
    <IOSProcessSection/>
    <IOSFeaturesSection/>
    <FinalCTA/>
    <Footer/>
    </>
  )
}

export default IOSApp